import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../store/slices/authSlice";
import { useNavigate, useSearchParams } from "react-router-dom";
import mbhcImage from "../../assets/images/mbhc-logo.jpg";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // Back to the page the user was on when the session expired (same-site paths only)
  const returnUrl = searchParams.get("returnUrl");
  const target =
    returnUrl &&
    returnUrl.startsWith("/") &&
    !returnUrl.startsWith("//") &&
    !returnUrl.startsWith("/login")
      ? returnUrl
      : "/"; // "/" picks My view or HR view
  const { status, error } = useSelector((state) => state.auth);

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userName || !password) return;

    const result = await dispatch(
      login({ username: userName, password: password }),
    );
    if (login.fulfilled.match(result)) {
      navigate(target, { replace: true });
    }
  };

  return (
    <div className="auth-page">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-10 col-md-8 col-lg-5 col-xl-4">
            <div className="glass-card shadow-lg p-4 p-sm-5">
              {/* BRANDING SECTION */}
              <div className="text-center mb-4">
                <div className="text-center mb-4">
                  <img
                    src={mbhcImage}
                    alt="Profile"
                    className="mx-auto shadow-lg object-fit-cover mb-3 auth-logo"
                  />
                </div>
                <h2 className="fw-bolder m-0 auth-brand-title">
                  HR<span className="text-blue-500">IS</span>
                </h2>
                <p className="text-muted small mt-2 fw-medium">
                  Sign In to your account
                </p>
              </div>

              {error && (
                <div className="alert alert-danger py-2 border-0 small mb-4 d-flex align-items-center rounded-3">
                  <i className="bi bi-exclamation-circle-fill me-2"></i>
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label fw-bold small text-secondary">
                    Email
                  </label>
                  <input
                    type="email"
                    className="form-control form-control-lg login-input fs-090 rounded-10"
                    placeholder="name@emi-solutions.ph"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    disabled={status === "loading"}
                    required
                  />
                </div>

                <div className="mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="form-label fw-bold small text-secondary m-0">
                      Password
                    </label>
                    <button
                      type="button"
                      className="btn btn-link p-0 text-decoration-none fw-bold auth-link"
                      onClick={() => navigate("/forgot-password")}
                    >
                      Forgot Password?
                    </button>
                  </div>
                  <div className="position-relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control form-control-lg login-input login-input--with-icon"
                      placeholder="••••••••"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      disabled={status === "loading"}
                      required
                    />
                    <button
                      type="button"
                      className="position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent pe-3 text-muted"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <i
                        className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                      ></i>
                    </button>
                  </div>
                </div>

                <div className="mb-4 form-check d-flex align-items-center">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="rem"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <label
                    className="form-check-label small text-muted fw-semibold ms-2 cursor-pointer fs-080"
                    htmlFor="rem"
                  >
                    Keep me logged in
                  </label>
                </div>

                <div className="d-grid">
                  <button
                    type="submit"
                    className="btn btn-primary btn-lg fw-bold shadow-sm btn-hover border-0 transition-all auth-submit"
                    disabled={status === "loading"}
                  >
                    {status === "loading" ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Authenticating...
                      </>
                    ) : (
                      "Sign In"
                    )}
                  </button>
                </div>
              </form>
            </div>

            <div className="text-center mt-4">
              <p className="text-white small opacity-75">
                &copy; 2026 EMI Solutions Philippines Inc.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
